import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function DesignationList() {
  const navigate = useNavigate();
  const columns = [
    { field: "DI_Id", label: "#" },
    { field: "DI_Name", label: "Designation" },
    { field: "DI_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.DI_Id));

        navigate(
          `/DesignationLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Designation/list`}
      actions={actions}
      title={`Designation`}
      linkvalue={`/DesignationLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default DesignationList;
